import { useEffect } from 'react';
import { useProjectStore } from '../stores/projectStore';
import { useLayoutStyleStore } from '../stores/layoutStyleStore';
import { createTabId } from '../../types';
import logger from '../utils/logger';

/**
 * ワークスペース切り替え時に自動的にタブを作成するフック
 * レイアウトスタイルに定義されたautoTabsConfigに基づいてタブを配置する
 */
export function useAutoTabCreation() {
  const project = useProjectStore((state) => state.project);
  const activeWorkspaceId = project?.activeWorkspaceId;
  const addTab = useProjectStore((state) => state.addTab);
  const getCurrentWorkspace = useProjectStore((state) => state.getCurrentWorkspace);
  const clearWorkspaceContext = useProjectStore((state) => state.clearWorkspaceContext);

  useEffect(() => {
    if (!activeWorkspaceId) return;

    const currentWorkspace = getCurrentWorkspace();
    if (!currentWorkspace) return;

    // 自動タブ作成が必要かチェック
    if (currentWorkspace.createdFromStyleId && currentWorkspace.creationContext) {
      const style = useLayoutStyleStore.getState().getStyleById(currentWorkspace.createdFromStyleId);

      if (style?.autoTabsConfig) {
        logger.info('[useAutoTabCreation] 自動タブ設定を検出:', {
          workspaceId: currentWorkspace.id,
          styleId: currentWorkspace.createdFromStyleId,
          context: currentWorkspace.creationContext
        });

        // タブ設定を作成
        const tabConfigs = style.autoTabsConfig.createTabs(currentWorkspace.creationContext);

        // レイアウトが完全に初期化されるのを待つ
        setTimeout(() => {
          tabConfigs.forEach(({ paneId, tab }) => {
            const tabWithId = {
              ...tab,
              id: tab.id || createTabId(`tab-${crypto.randomUUID()}`)
            };
            addTab(paneId, tabWithId);
          });

          logger.info('[useAutoTabCreation] 自動タブ追加が完了しました');

          // 一度タブを作成したらコンテキストをクリア（重複作成を防ぐ）
          clearWorkspaceContext(currentWorkspace.id);
        }, 100);
      }
    }
  }, [activeWorkspaceId, addTab, getCurrentWorkspace, clearWorkspaceContext]);
}
